// ─────────────────────────────────────────────
//  CapitalInput.jsx
//  Entrada del capital inicial de inversión
// ─────────────────────────────────────────────

import React, { useRef } from 'react';
import styles from './CapitalInput.module.css';

export default function CapitalInput({ value, onChange, onReset }) {
	const inputRef = useRef(null);

	const handleChange = (e) => {
		const raw = e.target.value;
		const sanitized = raw.replace(/[^0-9.]/g, '');
		const parts = sanitized.split('.');
		if (parts.length > 2) return;
		if (parts[1] !== undefined && parts[1].length > 2) return;
		if (parseFloat(sanitized) > 99999999.99) return;
		onChange(sanitized);
	};

	return (
		<section className={styles.card} aria-label="Capital inicial de inversión">
			{value ? (
				<button
					type="button"
					className={styles.resetBtn}
					onClick={() => { onReset?.(); inputRef.current?.focus(); }}
					aria-label="Reiniciar calculadora de inversión"
				>
					<span aria-hidden="true">↺</span> Reiniciar
				</button>
			) : null}

			<div
				className={styles.inputWrap}
				onClick={() => inputRef.current?.focus()}
			>
				<span className={styles.currency} aria-hidden="true">$</span>
				<input
					ref={inputRef}
					className={styles.input}
					type="text"
					inputMode="decimal"
					value={value}
					placeholder="Capital inicial"
					aria-label="Capital inicial de inversión"
					onChange={handleChange}
				/>
			</div>
		</section>
	);
}
